import { faEuro } from '@fortawesome/pro-regular-svg-icons/faEuro'
import { NumberInput, type NumberInputProps } from '@mantine/core'
import { useEffect, useState } from 'react'

import { useCurrencyUtils } from '@flecto/utils'

import { Icon } from '../../src'

export type InputCurrencyProps = Omit<
  NumberInputProps,
  'value' | 'onChange' | 'onBlur'
> & {
  value?: number
  onChange?: (cents: number) => void
  onBlur?: (cents: number) => void
}

export function InputCurrency(props: InputCurrencyProps) {
  const { centsToFloat, floatToCents } = useCurrencyUtils()
  const [localValue, setLocalValue] =
    useState<NumberInputProps['value']>(undefined)

  useEffect(() => {
    if (!props.value && props.value !== 0) {
      setLocalValue(undefined)
      return
    }

    setLocalValue(centsToFloat(Number(props.value)))
  }, [props.value])

  return (
    <NumberInput
      {...props}
      allowNegative={false}
      leftSection={<Icon icon={faEuro} />}
      allowDecimal
      placeholder='0,00'
      decimalSeparator=','
      thousandSeparator='.'
      hideControls
      value={localValue}
      decimalScale={2}
      fixedDecimalScale
      onChange={(value) => {
        const centsOriginal = floatToCents(Number(value))

        const cents =
          props.max && centsOriginal > props.max ? props.max : centsOriginal

        setLocalValue(centsToFloat(cents))

        props.onChange?.(cents)
      }}
      onBlur={(e) => {
        const cents = floatToCents(
          parseFloat((e.target as HTMLInputElement).value)
        )
        props.onBlur?.(cents)
      }}
    />
  )
}
